// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip {
  position: absolute;
  z-index: 20
}

/* TOOLTIP WORKAROUND FOR ARROW UP */
.tooltip.tooltip-bottom .tooltip-box::before {
  position: absolute;
  z-index: 10;
  --tw-bg-opacity: 1;
  background-color: rgb(9 12 41 / var(--tw-bg-opacity));
  content: '';
  width: 14px;
  height: 1px;
  top: -1px;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%)
}

.tooltip.tooltip-top .tooltip-box::before {
  position: absolute;
  z-index: 10;
  --tw-bg-opacity: 1;
  background-color: rgb(9 12 41 / var(--tw-bg-opacity));
  content: '';
  width: 14px;
  height: 1px;
  bottom: -1px;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%)
}

.tooltip.tooltip-bottom {
  margin-top: 0.25rem;
  padding-top: 0.5rem;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%)
}

.tooltip.tooltip-top {
  margin-bottom: 0.25rem;
  padding-bottom: 0.5rem;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  bottom: 100%
}

.tooltip.tooltip-bottom-left {
  margin-top: 0.25rem;
  padding-top: 0.5rem;
  left: 0
}

.tooltip.tooltip-bottom-right {
  margin-top: 0.25rem;
  padding-top: 0.5rem;
  right: 0
}

.tooltip.tooltip-left {
  margin-right: 1rem;
  top: 50%;
  right: calc(100%);
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%)
}

.tooltip.tooltip-right {
  margin-left: 1rem;
  top: 50%;
  left: calc(100%);
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%)
}

.tooltip.tooltip-right .tooltip-box::before {
  position: absolute;
  z-index: 10;
  --tw-bg-opacity: 1;
  background-color: rgb(9 12 41 / var(--tw-bg-opacity));
  content: '';
  width: 2px;
  height: 15px;
  left: -1px;
  top: 50%;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%)
}

.tooltip.tooltip-left .tooltip-box::before {
  position: absolute;
  z-index: 10;
  --tw-bg-opacity: 1;
  background-color: rgb(9 12 41 / var(--tw-bg-opacity));
  content: '';
  width: 2px;
  height: 15px;
  right: -1px;
  top: 50%;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%)
}

.tooltip.tooltip-bottom-right .tooltip-box::before {
  position: absolute;
  z-index: 10;
  --tw-bg-opacity: 1;
  background-color: rgb(9 12 41 / var(--tw-bg-opacity));
  content: '';
  width: 15px;
  height: 2px;
  right: 5px;
  top: -1px
}

.tooltip.tooltip-bottom-left .tooltip-box::before {
  position: absolute;
  z-index: 10;
  --tw-bg-opacity: 1;
  background-color: rgb(9 12 41 / var(--tw-bg-opacity));
  content: '';
  width: 15px;
  height: 2px;
  left: 5px;
  top: -1px
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/Tooltip/tooltip.css"],"names":[],"mappings":"AACE;EAAA,kBAAoB;EAApB;AAAoB;;AAGtB,oCAAoC;AAElC;EAAA,kBAAoC;EAApC,WAAoC;EAApC,kBAAoC;EAApC,qDAAoC;EACpC,WAAW;EACX,WAAW;EACX,WAAW;EACX,SAAS;EACT,SAAS;EACT,mCAA2B;UAA3B;AANoC;;AAUpC;EAAA,kBAAoC;EAApC,WAAoC;EAApC,kBAAoC;EAApC,qDAAoC;EACpC,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mCAA2B;UAA3B;AANoC;;AAUpC;EAAA,mBAAgB;EAAhB,mBAAgB;EAChB,SAAS;EACT,mCAA2B;UAA3B;AAFgB;;AAMhB;EAAA,sBAAgB;EAAhB,sBAAgB;EAChB,SAAS;EACT,mCAA2B;UAA3B,2BAA2B;EAC3B;AAHgB;;AAOhB;EAAA,mBAAgB;EAAhB,mBAAgB;EAChB;AADgB;;AAKhB;EAAA,mBAAgB;EAAhB,mBAAgB;EAChB;AADgB;;AAKhB;EAAA,kBAAW;EACX,QAAQ;EACR,iBAAiB;EACjB,mCAA2B;UAA3B;AAHW;;AAOX;EAAA,iBAAW;EACX,QAAQ;EACR,gBAAgB;EAChB,mCAA2B;UAA3B;AAHW;;AAOX;EAAA,kBAAoC;EAApC,WAAoC;EAApC,kBAAoC;EAApC,qDAAoC;EACpC,WAAW;EACX,UAAU;EACV,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,mCAA2B;UAA3B;AANoC;;AAUpC;EAAA,kBAAoC;EAApC,WAAoC;EAApC,kBAAoC;EAApC,qDAAoC;EACpC,WAAW;EACX,UAAU;EACV,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,mCAA2B;UAA3B;AANoC;;AAUpC;EAAA,kBAAoC;EAApC,WAAoC;EAApC,kBAAoC;EAApC,qDAAoC;EACpC,WAAW;EACX,WAAW;EACX,WAAW;EACX,UAAU;EACV;AALoC;;AASpC;EAAA,kBAAoC;EAApC,WAAoC;EAApC,kBAAoC;EAApC,qDAAoC;EACpC,WAAW;EACX,WAAW;EACX,WAAW;EACX,SAAS;EACT;AALoC","sourcesContent":[".tooltip {\r\n  @apply absolute z-20;\r\n}\r\n\r\n/* TOOLTIP WORKAROUND FOR ARROW UP */\r\n.tooltip.tooltip-bottom .tooltip-box::before {\r\n  @apply bg-primary-dark absolute z-10;\r\n  content: '';\r\n  width: 14px;\r\n  height: 1px;\r\n  top: -1px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n}\r\n\r\n.tooltip.tooltip-top .tooltip-box::before {\r\n  @apply bg-primary-dark absolute z-10;\r\n  content: '';\r\n  width: 14px;\r\n  height: 1px;\r\n  bottom: -1px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n}\r\n\r\n.tooltip.tooltip-bottom {\r\n  @apply mt-1 pt-2;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n}\r\n\r\n.tooltip.tooltip-top {\r\n  @apply mb-1 pb-2;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  bottom: 100%;\r\n}\r\n\r\n.tooltip.tooltip-bottom-left {\r\n  @apply mt-1 pt-2;\r\n  left: 0;\r\n}\r\n\r\n.tooltip.tooltip-bottom-right {\r\n  @apply mt-1 pt-2;\r\n  right: 0;\r\n}\r\n\r\n.tooltip.tooltip-left {\r\n  @apply mr-4;\r\n  top: 50%;\r\n  right: calc(100%);\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.tooltip.tooltip-right {\r\n  @apply ml-4;\r\n  top: 50%;\r\n  left: calc(100%);\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.tooltip.tooltip-right .tooltip-box::before {\r\n  @apply bg-primary-dark absolute z-10;\r\n  content: '';\r\n  width: 2px;\r\n  height: 15px;\r\n  left: -1px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.tooltip.tooltip-left .tooltip-box::before {\r\n  @apply bg-primary-dark absolute z-10;\r\n  content: '';\r\n  width: 2px;\r\n  height: 15px;\r\n  right: -1px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n}\r\n\r\n.tooltip.tooltip-bottom-right .tooltip-box::before {\r\n  @apply bg-primary-dark absolute z-10;\r\n  content: '';\r\n  width: 15px;\r\n  height: 2px;\r\n  right: 5px;\r\n  top: -1px;\r\n}\r\n\r\n.tooltip.tooltip-bottom-left .tooltip-box::before {\r\n  @apply bg-primary-dark absolute z-10;\r\n  content: '';\r\n  width: 15px;\r\n  height: 2px;\r\n  left: 5px;\r\n  top: -1px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
